import { InputSelect, InputSelectProps } from './Input_Select'
import { QueryFunction, QueryKey, useQuery } from '@tanstack/react-query'

export interface InputAsyncSelectProps extends Omit<InputSelectProps, 'data'> {
  queryKey: QueryKey
  queryFn: QueryFunction<NonNullable<InputSelectProps['data']>, QueryKey>
}

export const InputAsyncSelect = ({
  queryKey,
  queryFn,
  required,
  ...props
}: InputAsyncSelectProps) => {
  const { data, isLoading } = useQuery({
    queryKey,
    queryFn,
    enabled: !props.disabled,
  })

  const items = data ?? []

  return (
    <InputSelect
      {...props}
      required={required}
      data={items}
      disabled={props.disabled || isLoading}
    />
  )
}
